<header>
<nav class="navbar p-0 bg-white">
  <div class="d-flex flex-wrap col-12">
  <div class="col-sm-12 d-flex justify-content-between flex-wrap align-center">
    <a
      class="navbar-brand"
      [class.disabled]="isHiddenHeader"
      [attr.href]="isHiddenHeader ? null : '/#/home'"
      [attr.aria-disabled]="isHiddenHeader"
      [attr.tabindex]="isHiddenHeader ? -1 : 0"
      >
        <img
          src="../../../../assets/logos/fgc-logo.svg"
          height="90" alt="Logo da FGC"
          loading="lazy"
        />
    </a>
    <ul  class="navbar-nav d-block flex-row d-none d-flex align-items-center  justify-content-around">
      <li *ngIf="!customHeader && !isHiddenHeader" class="nav-item mx-3">
        <a href="https://www.fgc.org.br" target="_blank" class="custom-fgc-label">Fale Conosco</a>
      </li>
      <li *ngIf="!customHeader && !isHiddenHeader" class="nav-item">
        <button data-testid="botao-solicitar-acompanhar" class="btn" (click)="openModal()">
          Solicitar e Acompanhar Minha Garantia
        </button>
      </li>
       <li *ngIf="customHeader && !isHiddenHeader" class="nav-item ml-2 mr-2">
          <a data-testid="botao-voltar-inicio" href="#" class="custom-fgc-label">
            Início
          </a>
        </li>
      </ul>
      </div>
    </div>
  </nav>
</header>
  <ng-content ></ng-content>
